import { createAction, createReducer } from 'redux-act';


const showNotificationAction = createAction('SHOW_NOTIFICATION');
const hideNotificationAction = createAction('HIDE_NOTIFICATION');

const DEFAULT_STATE = { text: null, buttonElement: null, visible: false, type: null, }
export const notificationReducer = createReducer(function (on, off) {
  on(showNotificationAction, (state, payload) => {
    return {
      text: payload.text,
      buttonElement: payload.buttonElement,
      visible: true,
      buttonText: payload.buttonText,
      type :payload.type 
    };
  });
  on(hideNotificationAction, (state, payload) => {
    return DEFAULT_STATE;
  });
}, DEFAULT_STATE);

export const showNotification = (text, type, timeout = 10000) => {
  return dispatch => {
    setTimeout(() => {
      dispatch(hideNotificationAction());
    }, timeout);
    return dispatch(showNotificationAction({ text, type }));
  }
}

export const showNotificationWithButton = (text, type, buttonElement) => {
  return dispatch => {
    setTimeout(() => {
      dispatch(hideNotificationAction());
    }, 10000);
    return dispatch(showNotificationAction({ text, type, buttonElement }));
  }
}


export const hideNotification = () => {
  return dispatch => {
    return dispatch(hideNotificationAction());
  }
}




